import { render } from "./Flmed.vue?vue&type=template&id=1c942347&scoped=true"
import script from "./Flmed.vue?vue&type=script&lang=js"
export * from "./Flmed.vue?vue&type=script&lang=js"

import "./Flmed.vue?vue&type=style&index=0&id=1c942347&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c942347"]])

export default __exports__